import axios from "axios";
import { API_URL } from "App";

const api = axios.create();

export const fetchBlogs = async () => {
  const response = await api.get(`${API_URL}/blog`);
  return response;
};

export const fetchBlogByID = async (id) => {
  const response = await api.get(`${API_URL}/blog/${id}`);
  return response;
};

export const fetchCommentsByBlogID = async (id) => {
  const response = await api.get(`${API_URL}/blog/${id}/comments`);
  return response;
};

export const postComment = async (id, comment) => {
  const response = await api.post(`${API_URL}/blog/${id}/comment`, comment);
  return response;
};
